<div mat-dialog-title>
  <h2>{{ title }}</h2>
</div>
<mat-progress-bar [mode]="(loading$ | async) ? 'indeterminate' : 'determinate'"></mat-progress-bar>

<mat-dialog-content>
  <ng-container *ngIf="history$ | async as logDays; else noHistory">
    <mat-accordion *ngIf="logDays.length > 0; else noHistory">
      <ng-container *ngFor="let day of logDays">
        <div fxLayout="row">
          <div fxFlex="100px" fxLayout="column">
            <span class="day-name">
              {{ day.date.calendar(null, calendarFormats).toUpperCase() }}
            </span>
            <span>
              {{ day.date | momentDate:tz }}
            </span>
          </div>

          <div fxFlex fxLayout="column">
            <ng-container *ngFor="let log of day.logs">
              <div fxLayout="row" class="log-date-row--log" [ngClass]="logRowClass" fxLayoutGap="10px">
                <div fxFlex="125px" class="log-date-row--time text-right" fxLayout="column" (click)="log.expanded = !log.expanded">
                  <span>{{ log.createdAt | momentTime:tz:'LTS' }}</span>
                </div>
                <div>
                  <ng-container *ngIf="logTemplate"
                    [ngTemplateOutlet]="logTemplate"
                    [ngTemplateOutletContext]="{ $implicit: log, log: log, day: day }">
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </mat-accordion>
  </ng-container>

  <ng-template #noHistory>
    <ng-container *ngIf="(loading$ | async) === false; else loading">
      <div class="text-center mt-5 mb-4">
        <p>{{ emptyText }}</p>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #loading>
    <div class="text-center mt-5 mb-4">
      {{ 'common.loading' | translate }}...
    </div>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Close</button>
</mat-dialog-actions>
